import { cn } from '@core/utils';

export const ResponsiveDivider = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'h-80 shrink-0',
        'tablet:h-10 tablet:bg-Gray-100',
        'mobile:h-10 mobile:bg-Gray-100',
        className,
      )}
    />
  );
};
